import { Input, Select } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import { useNumberFormat } from 'hooks/useNumberFormat';
import styles from './EarlyRepaymentCalculator.module.css';

export const DisabledEarlyRepaymentCalculator = () => {
  const { formatCurrency } = useNumberFormat();
  const value = formatCurrency(0);

  const renderValue = () => {
    return <p className={styles.summaryValue}>{value}</p>;
  };

  return (
    <div className={clsx(styles.earlyRepaymentCalculator, styles.disabled)}>
      <h2 className={styles.heading}>
        <Trans>Calculate repayment</Trans>
      </h2>
      <div className={styles.repaymentOptions}>
        <div className={styles.repaymentOption}>
          <Trans>If the applicant borrows</Trans>
          <Input disabled className={styles.repaymentOptionInput} value={0} />
        </div>
        <div className={styles.repaymentOption}>
          <Trans>and repays</Trans>
          <div className={styles.dateInputs}>
            <Select disabled className={styles.repaymentOptionInput}>
              <option value="1-month">
                <Trans>in 1 month</Trans>
              </option>
            </Select>
          </div>
        </div>
      </div>
      <div className={styles.repaymentValues}>
        <div className={styles.summaryItem}>
          <p className={styles.summaryHeading}>
            <Trans>Early repayment fee</Trans>:
          </p>
          {renderValue()}
        </div>
        <div className={styles.summaryItem}>
          <p className={styles.summaryHeading}>
            <Trans>Total fees + interest</Trans>:
          </p>
          {renderValue()}
        </div>
        <div className={styles.summaryItem}>
          <p className={styles.summaryHeading}>
            <Trans>Total repayment</Trans>:
          </p>
          {renderValue()}
        </div>
        <div className={clsx(styles.moneySaved, styles.summaryItem)}>
          <p className={styles.summaryHeading}>
            <Trans>Total savings</Trans>:
          </p>
          {renderValue()}
        </div>
      </div>
    </div>
  );
};
